import { render, staticRenderFns } from "./PopupContent.vue?vue&type=template&id=e0e7645e&"
import script from "./PopupContent.vue?vue&type=script&lang=js&"
export * from "./PopupContent.vue?vue&type=script&lang=js&"
import style0 from "./PopupContent.vue?vue&type=style&index=0&id=e0e7645e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports